<template>
<div class="container-fluid">


<div class="card border-primary" >
  <div class="card-header text-white bg-primary" >
    <h4>
      <i style="color:yellow" class="fa fa-edit mr-2" aria-hidden="true"></i>
      REGISTRAZIONE/MODIFICA ORDINE FORNITORE
    </h4>
    </div>

    <div class="card-body">  
      <div v-if="contentType=='A'">
        <div class="card border-0">
        <div class="btn-group" role="group" aria-label="Basic example">
        <button  @click="order={},setNewOrder(),contentType='B'" type="button"  class="btn btn-warning mb-1 ">
        <i style="color:black" class="fas fa-edit mr-2" aria-hidden="true"></i>
          NUOVO ORDINE  
        </button>       
          
       
        </div>        
        </div>
        <supplier-orders  v-bind:edit="true"  @update="setOrderData"></supplier-orders>
    
      </div>
      <!--
            <div v-else-if="contentType=='H'">

          <div class="card border-0">
        <div class="btn-group" role="group" aria-label="Basic example">
            <button  @click="contentType='A'" type="button"  class="btn  btn-secondary mb-1 ">
            <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
              RITORNA A REGISTRAZIONE ORDINE
            </button>

              <button  @click="order={},setNewOrder(),contentType='B'" type="button"  class="btn btn-primary mb-1 ">
              <i style="color:yellow" class="fas fa-edit mr-2" aria-hidden="true"></i>
                NUOVO ORDINE1  
              </button>       
        </div>
        </div>

        <supplier-orders  v-bind:edit="true"  @update="setOrderData"></supplier-orders>
      </div>  -->
        
      <!-- NEW ORDER  -->
      <div v-else-if="contentType == 'B'">
        <order-header @close="contentType = 'A'" v-bind:_order="order" v-bind:type="'A'"  @update="setOrderData"/>          
      </div>


      <div v-else-if="contentType == 'C'">
       <order-info :key="orderInfoKey" v-bind:orderId="order.orderId"></order-info>

       <div class="card border-0">       
          <div class="btn-group" role="group" aria-label="Basic example">  

            
                <button  @click="contentType='A'" type="button"  class="btn  btn-secondary">
                    <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
                    RITORNA A RICERCA ORDINE
                </button>           
                <button @click="contentType='F'" type="button"  class="btn  btn-info">
                  <i style="color:yellow" class="fas fa-list mr-2" aria-hidden="true"></i>
                  LISTA PRODOTTI ORDINE
              </button>    

        </div>
        
        </div>

        <!-- NEW PRODUCT ON ORDER -->
        <div  class="card border-info mt-1 ml-1 mr-1 mb-1 border-warning shadow">
          <h4 class="card-header bg-light  border-warning">
            <i class="far fa-edit mr-2" aria-hidden="true"></i>
            <strong >REGISTRAZIONE ANAGRAFICA PRODOTTO </strong></h4>
          <div class="card-body">

            
            <product-master :key="productKey" v-bind:order="order"  @update="setProductStock" v-bind:orderId="order.orderId"  v-bind:supplierId="supplierId" v-bind:_product="product"/>
          </div>
        </div>

        

      </div>

      <!-- PRODUCT STOCK ON ORDER -->
      <div v-else-if = "contentType == 'D'">
        <order-info v-bind:orderId="order.orderId"></order-info>
        <product-qty-detail @back="setProductForm()" @update="setProductPriceDetail" v-bind:product="product"></product-qty-detail>  
      </div>

      <div v-else-if = "contentType == 'E'">

        <div v-if="UpdateBarcodesSupplier">
          <cancel-btn  @click="cleanUp()" v-bind:text="'RITORNA A REGISTRAZIONE ORDINE'" class="mb-1 "></cancel-btn>
          <span style="color:blue">ASSOCIAZIONE EAN FORNITORE</span>
        
          <supplierBarcodes v-bind:item="product" ></supplierBarcodes>
          
        </div>

        <div v-else>        
        <order-info v-bind:orderId="order.orderId"></order-info>        

        <!-- ORDINE DETTAGLIO PREZZI DI ACQUISTO E VENDITA -->
        <product-price-detail @update="cleanUp" v-bind:product="product" v-bind:orderId="order.orderId" ></product-price-detail>
      
      
        
        
        
        </div>

      </div>

      <div v-else-if = "contentType == 'F'">
        <order-info  v-bind:orderId="order.orderId"></order-info>  
        <div class="card border-0">
         <div class="btn-group" role="group" aria-label="Basic example">
          
          <button  @click="contentType='A'" type="button"  class="btn  btn-secondary">
                <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
              RITORNA A RICERCA ORDINE
          </button>           

          
          
          <button  @click="setProductFormFromUpdateOrder()" type="button"  class="btn btn-primary ">
            <i style="color:yellow" class="fas fa-edit mr-2" aria-hidden="true"></i>
            REGISTRA PRODOTTO
          </button>  
          
        </div>

       </div>

        <products-list @update="updateProduct" @change="type=false" :key="productsKey" v-bind:orderId="order.orderId"></products-list>

      </div>
      <div v-else-if = "contentType == 'G'">

        <order-info  v-bind:orderId="order.orderId"></order-info>  
        
          <div class="card border-0 mb-3">
           <div class="btn-group" role="group" aria-label="Basic example">
          

        <button  @click="contentType='A'" type="button"  class="btn  btn-secondary">
                <i style="color:yellow" class="fas fa-reply mr-2" aria-hidden="true"></i>
              RITORNA A RICERCA ORDINE
          </button>           
        <button @click="contentType='F'" type="button"  class="btn btn-info  ">
            <i style="color:yellow" class="fas fa-list mr-2" aria-hidden="true"></i>
           LISTA PRODOTTI
        </button>            

        </div>
        </div>

        <product-qty-update @update="HouseKeeping()"  v-bind:productId="product.productId" v-bind:order="order" ></product-qty-update> 

      </div>
    

  </div>
 
</div>
  
<!-- MAIN DIV -->
</div>

</template>
<script>




// import api                 from '@/api'

import orderHeader         from '@/components/order/OrderHeader.vue'
import productMaster       from '@/components/order/ProductForm.vue'
import productQtyDetail    from '@/components/order/ProductVariants.vue'
import productPriceDetail  from '@/components/order/PriceUpForm.vue'
import orderInfo           from '@/components/order/OrderInfo.vue'
import productsList        from '@/components/order/OrderProducts.vue'
import supplierOrders      from '@/components/order/SupplierOrders.vue'


import supplierList        from '@/components/supplier/SupplierList.vue'
import pushState           from '@/components/mixins/pushState.js'


import productQtyUpdate    from '@/components/order/ProductVariantsUpdate.vue'


import productInfo         from '@/components/product/ProductInfo.vue'
import supplierBarcodes    from '@/components/backOffice/ready/tab/SupplierBarcodes.vue'

import cancelBtn           from '@/components/common/CancelBtn.vue'
export default {
  mixins:[pushState],
  components: {orderHeader,
    productMaster,productQtyDetail,
    productPriceDetail,
    orderInfo,productsList,
    supplierOrders,supplierList,productQtyUpdate,
    
    productInfo,
    supplierBarcodes,cancelBtn},  
 
  data () {
    return {
    
      
      UpdateBarcodesSupplier : false,
      contentType   : 'A',
      supplierId    : 0,  
      type          : true,


      product      : {'productId':0,'barcodes':[],'counter':0,'sizes':[]},
      productKey   : 0,
      productsKey  : 0,
      order        : {},
      orderInfoKey : 0,
    
      items        : [],
      
      
      bt_spinner   : false


  }
  },

computed: 
{},
mounted()
{},
created()
{},

methods: 
{
  cleanUp()
  {
    this.UpdateBarcodesSupplier = false
    this.setNewProduct()
    this.contentType = 'C'
    this.orderInfoKey++
    this.productsKey++
    this.$store.commit('AUTH_LOGOUT_BTN',0)          
  },
  setNewProduct()
  {
    this.product.productId = 0
    this.contentType = 'C'
  },
  HouseKeeping()
  {
    this.$store.commit('AUTH_LOGOUT_BTN',false)
    this.contentType = 'F'
  },
  updateProduct(productId)
  {
    
    this.product.productId = productId
    this.contentType = 'G'
  },

  
  setProductForm()
  {
    
    this.$store.commit('AUTH_LOGOUT_BTN',0)
    this.contentType = 'C'
  },
  setProductFormFromUpdateOrder()
  {
    this.product.productId = 0
    this.$store.commit('AUTH_LOGOUT_BTN',0)
    this.contentType = 'C'
  },
  setOrderData(data)
  { 
    this.order       = data
    this.supplierId  = data.supplierId
    //this.contentType = 'C'
    this.contentType = 'F'
  },
  
  setProductStock(data)  
  { 
    

    this.product = data
    this.$store.commit('AUTH_LOGOUT_BTN',1)
    this.contentType = 'D'

  },
  
  setProductPriceDetail(barcodes,sizes,counter)
  {


    this.product.barcodes = barcodes
    this.product.sizes = sizes
    this.product.counter = counter
    this.contentType = 'E'
  },

  openConfirmBox(items)
  {
        
    this.items = items
    this.cb.show = true
    
  },

  setNewProduct()
  {
   

    this.product.productId  = 0
    this.product.sku        = ''
    this.product.supplierId = this.supplierId
    this.product.barcodes   = []
    this.product.counter    = 0
   

  },
  setNewOrder()
  {
    this.product = {}
    this.setNewProduct()
  },
  
  
      
}
    
}    
</script>

<style scoped>

.bold {
  font-weight: bolder;
}

h4,span {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
.header_1 {
  background-color:burlywood;
}


.btn-warning{
  color : white !important;
  background-color: rgb(0, 139, 107) !important;
}
.card-header
{
  height: 45px;
}

</style>